import { render, staticRenderFns } from "./app-loader.vue?vue&type=template&id=9f62749a&"
import script from "./app-loader.vue?vue&type=script&lang=js&"
export * from "./app-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports